/**
 * Release Notes API Services
 *
 * This module provides functions to interact with the release notes API
 * endpoints.
 */
import axios from "axios";
import { getAuthHeaders } from "../helpers";

const BASE_URL = process.env.REACT_APP_SERVER_URL || "";

/**
 * Fetch release notes with pagination
 * @param {number} page - Page number (default: 1)
 * @param {number} perpage - Items per page (default: 10)
 * @returns {Promise} - Axios promise with the API response
 */
export const getReleaseNotes = (page = 1, perpage = 10) => {
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const url = `${baseUrl}/admin/release_notes?page=${page}&perpage=${perpage}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * Create a new release note
 * @param {Object} data - Release note data (title, note_text, publish)
 * @returns {Promise} - Axios promise with the API response
 */
export const createReleaseNote = data =>
  axios.post(`${BASE_URL}/admin/release_notes`, data, {
    headers: getAuthHeaders()
  });

/**
 * Update an existing release note
 * @param {string|number} id - ID of the release note to update
 * @param {Object} data - Updated release note data (title, note_text, publish)
 * @returns {Promise} - Axios promise with the API response
 */
export const updateReleaseNote = (id, data) =>
  axios.put(`${BASE_URL}/admin/release_notes/${id}`, data, {
    headers: getAuthHeaders()
  });

/**
 * Delete a release note
 * @param {string|number} id - ID of the release note to delete
 * @returns {Promise} - Axios promise with the API response
 */
export const deleteReleaseNote = id =>
  axios.delete(`${BASE_URL}/admin/release_notes/${id}`, {
    headers: getAuthHeaders()
  });
